import { awsRegion, identityPoolId, oauthDomain, userPoolClientId, userPoolId } from './environment'

const redirectUrl = `${window.location.origin}/`

export const authConfig = {
  userPoolWebClientId: userPoolClientId,
  region: awsRegion,
  userPoolId: userPoolId,
  identityPoolId: identityPoolId,
  oauth: {
    domain: oauthDomain,
    scopes: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: redirectUrl,
    redirectSignOut: redirectUrl,
    responseType: 'code'
  }
}
